import React from 'react';
import styled from '@emotion/styled';
import { Fonts, Spacings, breakpoints, mediaQuery } from '@styles/index';
import Thumbnail from '@base/Thumbnail/Thumbnail';
import Typography from '@unicons-base/Typography/Typography';
import UN_ICONS_TYPOGRAPHY_VARIANT from 'types/unacademyIcons/typography.type';

interface CarouselCourseCardProps {
  title: string;
  tagline: string;
  cover: string;
  mobileHeight?: string;
  desktopHeight?: string;
}

const CardWrapper = styled.div`
  position: relative;
`;

const Tagline = styled(Typography)`
  font-weight: ${Fonts.REGULAR};
  color: var(--color-i-icon-dark-secondary);
  margin: 0;
  ${mediaQuery.uptoTablet} {
    margin: 0;
  }
`;

const Title = styled(Typography)`
  margin-bottom: ${Spacings.SPACING_1B};
  color: var(--color-i-icon-light-tertiary);
  font-weight: ${Fonts.BOLD};
  ${mediaQuery.uptoTablet} {
    font-weight: ${Fonts.SEMIBOLD};
    margin-bottom: ${Spacings.SPACING_1B};
  }
`;

type ThumbnailType = {
  $desktopHeight: string;
  $mobileHeight: string;
};

const StyledThumbnail = styled(Thumbnail)<ThumbnailType>`
  height: ${({ $desktopHeight }) => $desktopHeight};
  width: 367px;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    height: ${({ $mobileHeight }) => $mobileHeight};
    width: 200px;
  }
`;

const TextWrapper = styled.div`
  position: absolute;
  bottom: 24px;
  left: 24px;
  ${mediaQuery.uptoTablet} {
    bottom: 12px;
    left: 12px;
  }
`;

const CarouselCourseCard: React.FC<CarouselCourseCardProps> = ({
  title,
  cover,
  tagline,
  mobileHeight,
  desktopHeight
}) => {
  return (
    <CardWrapper>
      <StyledThumbnail
        imgUrl={cover}
        orientation="horizontal"
        borderRadius="8px"
        $mobileHeight={mobileHeight}
        $desktopHeight={desktopHeight}
        isUnoptimized
      />
      <TextWrapper>
        <Title variant={UN_ICONS_TYPOGRAPHY_VARIANT.SUBTITLE1}>{title}</Title>
        <Tagline variant={UN_ICONS_TYPOGRAPHY_VARIANT.BODY2}>{tagline}</Tagline>
      </TextWrapper>
    </CardWrapper>
  );
};

CarouselCourseCard.defaultProps = {
  mobileHeight: '150px',
  desktopHeight: '278px'
};

CarouselCourseCard.displayName = 'CarouselCourseCard';

export default CarouselCourseCard;
